import React, { useState } from 'react';

const DashboardPage = ({ userWidgets, isLicenseActive, onNavigate }) => {
  const [dateFilter, setDateFilter] = useState('last7days');
  
  const stats = {
    totalConversations: 1247,
    satisfactionRate: 94
  };

  const isFirstTimeUser = userWidgets.length === 0;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 py-8">
        
        {/* First-Time User Welcome Banner */}
        {isFirstTimeUser && (
          <div style={{
            background: 'linear-gradient(135deg, #06ADED, #38BFEF)',
            borderRadius: '1.5rem',
            padding: '2.5rem',
            marginBottom: '2rem',
            color: 'white',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '200px',
              height: '200px',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '50%'
            }} />
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '-30px',
              width: '150px',
              height: '150px',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '50%'
            }} />
            
            <div style={{ position: 'relative', zIndex: 1 }}>
              <h2 style={{
                fontSize: '2rem',
                fontWeight: '700',
                marginBottom: '0.75rem',
                margin: 0
              }}>
                Welcome to Defindly
              </h2>
              <p style={{
                fontSize: '1.125rem',
                opacity: 0.95,
                marginBottom: '1.5rem',
                maxWidth: '600px'
              }}>
                Let's get your AI chat assistant up and running. Create your first widget to get started.
              </p>
              <button
                onClick={() => onNavigate('widgetBuilder')}
                style={{
                  background: 'white',
                  color: '#06ADED',
                  border: 'none',
                  padding: '1rem 2rem',
                  borderRadius: '0.75rem',
                  fontWeight: '700',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
              >
                Create Your First Widget
              </button>
            </div>
          </div>
        )}

        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="page-title">Dashboard</h1>
            <p className="page-subtitle">Monitor your AI widget performance and activity</p>
          </div>
          
          <select 
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
            className="form-select"
            style={{ width: 'auto', minWidth: '150px' }}
          >
            <option value="today">Today</option>
            <option value="last7days">Last 7 days</option>
            <option value="last30days">Last 30 days</option>
            <option value="last3months">Last 3 months</option>
          </select>
        </div>

        <div className="grid grid-cols-2 gap-6 mb-8">
          <div className="card-metric">
            <div className="metric-label">Conversations</div>
            <div className="metric-value">{stats.totalConversations.toLocaleString()}</div>
            <div className="text-success">+12% from last month</div>
          </div>

          <div className="card-metric">
            <div className="metric-label">Satisfaction Rate</div>
            <div className="metric-value" style={{ fontSize: '2.5rem' }}>{stats.satisfactionRate}%</div>
            <div className="text-sm text-gray-500">User feedback score</div>
          </div>
        </div>

        <div className="card p-6">
          <h3 className="section-title">License Status</h3>
          {isLicenseActive ? (
            <div className="license-active">
              <div className="text-lg font-bold text-gray-900 mb-2">Active License</div>
              <div className="text-sm text-gray-600 mb-4">Your license is active and working properly</div>
              <div className="text-sm font-medium text-gray-700">284 days remaining</div>
              <div className="mt-4 h-2 bg-gray-200 rounded-full overflow-hidden">
                <div 
                  className="h-full rounded-full"
                  style={{ 
                    width: '78%',
                    background: 'linear-gradient(135deg, #06ADED, #38BFEF)'
                  }}
                ></div>
              </div>
            </div>
          ) : (
            <div className="license-inactive">
              <div className="text-lg font-bold text-gray-900 mb-2">No Active License</div>
              <div className="text-sm text-gray-600 mb-4">Activate a license to unlock all features</div>
              <button className="btn-primary" onClick={() => onNavigate('license')}>
                Activate License
              </button>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default DashboardPage;